export const STATES = {
  IDLE: 'idle',
  RECORDING: 'recording',
  TRANSCRIBING: 'transcribing',
  THINKING: 'thinking',
  CLARIFY: 'clarify',
  CONFIRMING: 'confirming',
  CALCULATING: 'calculating',
  RESULT: 'result',
  ERROR: 'error',
};

export const BUSY_STATES = [STATES.TRANSCRIBING, STATES.THINKING, STATES.CALCULATING];
